import logger from 'loglevel'
import { config } from '~/config'

logger.setLevel(config.IS_PRODUCTION ? 'ERROR' : 'DEBUG')
